export const SCOPE_TYPE_READ = 'read';
export const SCOPE_TYPE_WRITE = 'write';

export type SCOPE_TYPE = typeof SCOPE_TYPE_READ | typeof SCOPE_TYPE_WRITE;
